import * as React from 'react'
import { TaskChangeCardConnected } from './TaskChangeCardConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const TaskChangeCardExamples = () => {
  return (
    <div className="TaskChangeCardExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskChangeCardConnected />
      </Provider>
    </div>
  )
}
